import { Dispatch, FC } from "react";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import FolderIcon from "../folder/folder-icon";
import { FolderInterface } from "../../../middleware/interfaces/folder/folder-interface";
import { FileInterface } from "../../../middleware/interfaces/file/file-interface";
import FileIcon from "../file/file-icon";
import ReportIcon from "../report/report-icon";
import { ReportInterface } from "../../../middleware/interfaces/report/report-interface";
import ForgeIcon from "../forge/forge-icon";
import { ForgeInterface } from "../../../middleware/interfaces/forge/forge-interface";
import { ProjectContentInterface } from "../../../middleware/interfaces/project/project-content-interface";
import { CollectVisibleProjectContent } from "../../../helper/ui/methods";

interface projectContentProps {
  user: UserInterface;
  selectedContent: ProjectContentInterface | null;
  setSelectedContent: Dispatch<any>;
}

const ProjectContent: FC<projectContentProps> = ({
  user,
  selectedContent,
  setSelectedContent,
}) => {
  const RenderProjectContent = (content: ProjectContentInterface) => {
    switch (content.type) {
      case "FolderInterface": {
        const folder = content as FolderInterface;
        return (
          <FolderIcon
            key={`folder-${folder.folderID}`}
            folderName={folder.folderName}
            isForged={folder.folderForged}
            isSelected={selectedContent === folder}
            onClick={() => setSelectedContent(folder)}
          />
        );
      }
      case "FileInterface": {
        const file = content as FileInterface;
        return (
          <FileIcon
            key={`file-${file.fileID}`}
            fileName={file.fileName}
            fileType={file.fileType!}
            isForged={file.forgeID !== null && file.forgeID !== undefined}
            isSelected={selectedContent === file}
            onClick={() => setSelectedContent(file)}
          />
        );
      }
      case "ReportInterface": {
        const report = content as ReportInterface;
        return (
          <ReportIcon
            key={`report-${report.reportID}`}
            reportName={report.reportName}
            isSelected={selectedContent === report}
            onClick={() => setSelectedContent(report)}
          />
        );
      }
      case "ForgeInterface": {
        const forge = content as ForgeInterface;
        return (
          <ForgeIcon
            key={`forge-${forge.forgeID}`}
            forgeName={forge.forgeName}
            isSelected={selectedContent === forge}
            onClick={() => setSelectedContent(forge)}
          />
        );
      }
      default:
        return <></>;
    }
  };

  return (
    <>{CollectVisibleProjectContent(user).map(RenderProjectContent)}</>
  );
};

export default ProjectContent;
